import React, { useEffect } from 'react';
import HomePage from './homePage/homePage';
import WorkOn from './workOn/workOn';
import Partners from './partners/partners';
import WhyUs from './whyus/whyUs';
import Services from './services/services.jsx'
import About from './about/about.jsx';
import FAQSection from './FAQSection.jsx';
import FloatingContact from './FloatingContact.jsx';
import { useLocation } from 'react-router-dom';
import HomeProductsSection from './products/ProductsHome.jsx';

export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Agar section scroll state nahi hai to top jao
    if (!location.state?.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
}


export default function App() {

  const location = useLocation();

  // Navigate hone ke baad section scroll
  useEffect(() => {
    if (location.state?.scrollTo) {

      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) {
          window.scrollTo({
            top: el.offsetTop - 90, // header height offset
            behavior: "smooth",
          });
        }
      }, 300);

      // State clear
      window.history.replaceState({}, document.title);

    }
  }, [location]);



  return (
    <>
      <ScrollToTop/>

      <HomePage />
      <HomeProductsSection/>
      <About/>
      
      <Services/>
      <WorkOn />
      <Partners />
      <WhyUs />
      <FAQSection/>
      <FloatingContact/>
    </>
  );
}